export default "__VITE_ASSET__RHbzfUKZ__"